var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _vm.professional.latitude
    ? _c("section", { attrs: { id: "professional-location" } }, [
        _c("div", { staticClass: "professional-section-title mb-3" }, [
          _vm.$i18n.locale === "en"
            ? _c("span", [
                _vm._v(
                  "\n      " +
                    _vm._s(_vm._f("firstName")(_vm.professional.name)) +
                    _vm._s(_vm.$t("message.professional.neighborhood")) +
                    "\n    "
                )
              ])
            : _c("span", [
                _vm._v(
                  "\n      " +
                    _vm._s(_vm.$t("message.professional.neighborhood")) +
                    " " +
                    _vm._s(_vm._f("firstName")(_vm.professional.name)) +
                    "\n    "
                )
              ])
        ]),
        _vm._v(" "),
        _c(
          "div",
          {
            staticClass: "embed-responsive embed-responsive-16by9 rounded-all"
          },
          [
            _c(
              "div",
              { staticClass: "embed-responsive-item" },
              [
                _c(
                  "gmap-map",
                  {
                    staticStyle: { width: "100%", height: "100%" },
                    attrs: {
                      center: _vm.center,
                      zoom: 13,
                      options: _vm.options
                    }
                  },
                  [
                    _c("gmap-circle", {
                      attrs: {
                        center: _vm.center,
                        radius: 1000,
                        options: _vm.mapCenterOptions
                      }
                    })
                  ],
                  1
                )
              ],
              1
            )
          ]
        )
      ])
    : _vm._e()
}
var staticRenderFns = []
render._withStripped = true
export { render, staticRenderFns }
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-106a1227", { render: render, staticRenderFns: staticRenderFns })
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-106a1227","hasScoped":false,"optionsId":"0","buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/professional/components/CleanerMap.vue
// module id = 1976
// module chunks = 0